export default __webpack_public_path__ + "static/media/www.f22d6679.md";